import { render, staticRenderFns } from "./SessionExpired.vue?vue&type=template&id=5fbd869f&scoped=true&"
import script from "./SessionExpired.vue?vue&type=script&lang=js&"
export * from "./SessionExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd869f",
  null
  
)

export default component.exports